import { defineComponent as _defineComponent } from 'vue'
import PinkShiftieCutOutSquareSvg from '@/assets/PinkShiftieCutOutSquareSvg.vue';
import ShiftieLogoAnimated from '@/assets/ShiftieLogoAnimated';
import ShiftieWhiteText from '@/assets/ShiftieWhiteText.vue';
import LoadingDot from '@/components/loaders/LoadingDot.vue';
import { viewport } from '@/util/windowFunctions';

export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftieLoading',
  setup(__props) {


return { __sfc: true,PinkShiftieCutOutSquareSvg, ShiftieLogoAnimated, ShiftieWhiteText, LoadingDot, viewport }
}

})